import { Component, OnInit, Input, HostListener, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import {
  User,
  AuthService,
  ApiService,
  EntityService,
  Entity,
  isMobile
} from '../../../core';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() public title: string;
  @Input() version: string;
  user$: Observable<User>;
  public store: Entity;
  public company: string;
  public isMobile = isMobile()
  newLogin = false;
  public showMenuChangeUser = false;
  public menuChangeUser = [];
  dataMultiSession;
  menu = [
    {
      id: 'administrar-cuenta',
      text: 'Administrar cuenta'
    },
    {
      id: 'autorizaciones',
      text: 'Autorizaciones'
    }
  ];
  menuModule: any[];
  constructor(
    public authService: AuthService,
    public apiService: ApiService,
    private entityService: EntityService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.newLogin = true;
  }
  
  @HostListener('window:storage', ['$event'])
  handleKeyDown(event: any) {
    const userStorage = JSON.parse(event.newValue);
    let oldUser = '';
    this.user$.subscribe(us => {
      oldUser = us.username;
    })
    if (userStorage && userStorage.user && userStorage.user.username !== oldUser) {      
      this.user$ = new Observable(ob => {ob.next(userStorage.user)});
      this.getUser(userStorage.user);
      window.location.reload();
    }
  }

  ngOnInit() {
    this.user$ = this.authService.user;
    this.user$.subscribe(session => {
      if (session && this.newLogin) {
        this.getUser(session);
      }
    });  
 }

  getUser(user) {
    this.entityService.getStores().then(stores => {
      if (stores) {
        const storeFound = stores.find(
          store => store.entityCode === user.entity.entityCode.toString()
        );
        this.store = storeFound ? storeFound : user.entity;
        if (!this.store) {
          this.logout();
        }
        this.company = user.entity.company.code;
        this.newLogin = false;
        this.cdr.markForCheck();
      }
    });

    this.menuModule = this.menu
      .filter(menu => this.authService.getUser().visibleModules.some(i => i.moduleIdentifier === menu.id));
    
    this.dataMultiSession = this.authService.getMultiSession();
    if (this.dataMultiSession) {
      let dataMultiSessionParse = JSON.parse(this.dataMultiSession);
      dataMultiSessionParse = dataMultiSessionParse.filter(element => {
          return element.username != user.username
      });
      if (dataMultiSessionParse.length >= 1) { 
        this.showMenuChangeUser = true;
        this.menuChangeUser = dataMultiSessionParse.map(element => {
          return element.username;
        });
      }
    }
  }

  redirect(url) {
    this.router.navigate(['/' + url]);
  }

  logout() {
    this.authService.logoutAndSaveAudit();
    this.router.navigate(['/iniciar-sesion']);
  }

  changeUserMenu(userName: string): void { 
    let dataMultiSessionParse = JSON.parse(this.dataMultiSession);
    let user = dataMultiSessionParse.find(element => {
      return element.username === userName;
    });
    this.authService.logout();
    this.authService.applyUser(user, dataMultiSessionParse);
    this.router.navigate(['/']).then(() => {
      window.location.reload();
    });
  }
}
